import React from 'react';

const tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};

class TextMessage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      label: this.props.label,
      value: this.props.value
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      })
    }
    if (this.state.label != nextProps.label) {
      this.setState({
        label: nextProps.label
      })
    }
  }

  replaceTag(tag) {
    return tagsToReplace[tag] || tag;
  }

  safe_tags_replace(str) {
    return String(str).replace(/[&<>]/g, this.replaceTag);
  }

  render() {
    let content = this.state.value ? this.safe_tags_replace(this.state.value) : '';
    return (
      <div className={this.props.className}>
        <div className="pt-label">
          <p className={`val-title-bold ${this.props.labelClass}`}>{this.state.label}</p>
          <p className={`val-content ${this.props.contentClass}`} dangerouslySetInnerHTML={{__html: content.replace(/\n/gi, '<br/>')}}></p>
        </div>
      </div>
    );
  }
}

TextMessage.defaultProps = {
  className: 'col-input',
  label: '',
  value: '',
  contentClass: '',
  labelClass: '',
  inline: false
}

export default TextMessage;


// WEBPACK FOOTER //
// ./src/components/tt-forms/common/TextMessage.jsx